import axios from "axios";

// insert all your axios logic here
const api = axios.create({ baseURL: "https://gamma.bfst.ir" });

export default {
  install: function (Vue) {
    Object.defineProperty(Vue.prototype, "$axios", { value: api });
  },
};

export { api };
